import type { GiantId } from '../../domain/ids/ids';
import type { LevelRunSnapshot } from './settleLevelRun';

export type ActiveLevelAttempt = {
  runKey: string;
  giantId: GiantId;
  orderIndex: number;
  snapshot: LevelRunSnapshot;
  terminalSettled: boolean;
};

const EMPTY_SNAPSHOT: LevelRunSnapshot = {
  elapsedSec: 0,
  sparksCollected: 0,
  sparksTotal: 0,
  speedBoostersCollected: 0,
  speedBoostersTotal: 0,
  collisions: 0,
};

let activeAttempt: ActiveLevelAttempt | null = null;

export function levelAttemptRunKey(
  giantId: GiantId,
  orderIndex: number,
  levelKey: number,
): string {
  return `${giantId}:${orderIndex}:${levelKey}`;
}

export function beginLevelAttempt(
  giantId: GiantId,
  orderIndex: number,
  levelKey: number,
): void {
  activeAttempt = {
    runKey: levelAttemptRunKey(giantId, orderIndex, levelKey),
    giantId,
    orderIndex,
    snapshot: { ...EMPTY_SNAPSHOT },
    terminalSettled: false,
  };
}

export function updateActiveLevelSnapshot(snapshot: LevelRunSnapshot): void {
  if (activeAttempt == null) {
    return;
  }
  activeAttempt = { ...activeAttempt, snapshot };
}

export function getActiveLevelAttempt(): ActiveLevelAttempt | null {
  return activeAttempt;
}

export function markLevelAttemptTerminalSettled(): void {
  if (activeAttempt == null) {
    return;
  }
  activeAttempt = { ...activeAttempt, terminalSettled: true };
}

export function clearLevelAttempt(): void {
  activeAttempt = null;
}

/** Test-only reset. */
export function __resetLevelRunSessionForTests(): void {
  activeAttempt = null;
}
